// wp_enqueue_script declares the WordPress jquery handle as a dependency.
// Share its plugin registry, events and data instead of bundling a second instance.
module.exports = window.jQuery;
